import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import { useState } from "react";
import moment from "moment";
import NoDataScreen from "../../utilities/NoDataScreen";

const useStylesForTable = makeStyles({
  table: {
    width: "max-content",
    minWidth: "40rem",
  },
});
interface tableHeadingAndData {
  heading: string[];
  data: any[];
  type: any;
  rows: any[];
}
const InventoryHandoverTableComponent = ({
  heading,
  data,
  type,
  rows,
}: tableHeadingAndData) => {
  const tableClasses = useStylesForTable();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {data.length > 0 ? (
        <>
          <TableContainer className="custom_table-container">
            <Table className={`${tableClasses.table} custom_table`} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {heading.map((heading: string, index: any): any => (
                    <TableCell
                      key={heading}
                      className={`f16 fw500 ${index === 0 && "pl0"}`}
                      align="left"
                    >
                      {heading}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {rows.length > 0 ? (<TableBody>
                {rows
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row: any, index: number) => (
                    <TableRow key={row.name + index}>
                      <TableCell className="f14 fw500 pl0" align="left">
                        {row.name}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row.quantity}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row.unit}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row?.handoverBy}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row?.handoverTo}
                      </TableCell>
                      <TableCell className="f14 fw500 capitalize" align="left">
                        {type === "Handover"
                          ? moment(row.handOverDate).format("DD,MMM,YYYY")
                          : row?.receivedDate
                            ? moment(row.receivedDate).format("DD,MMM,YYYY")
                            : "N/A"}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row.shiftOfReceivingEngineer}
                      </TableCell>
                      <TableCell title={row.status === "partially_accepted"
                          ? row.reasonForPartiallyAccepted
                          : row.status === "rejected"
                            ? row.reasonForRejection
                            : ""}className="f14 fw500 capitalize truncate" align="left">
                        {row.status === "partially_accepted"
                          ? row.reasonForPartiallyAccepted
                          : row.status === "rejected"
                            ? row.reasonForRejection
                            : "N/A"}
                      </TableCell>
                      <TableCell className="f14 fw500 capitalize" align="left">
                        <span
                          className={`${row.status === "accepted"? "text--success": row.status === "partially_accepted"
                            ? "text--primary"
                            : row.status === "rejected"
                              ? "text--danger"
                              : row.status === "approved"
                                ? "text--above-threshold"
                                : "text--warning"
                            }`}
                        >
                          {row?.status ? row?.status : "pending"}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>) : (<TableRow>
                <TableCell colSpan={10} align="center">
                  No Data Found
                </TableCell>
              </TableRow>)}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[2, 5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : (
        <NoDataScreen
          text={`There are no data available for Inventory Handover.`}
        />
      )}
    </>
  );
};

export default InventoryHandoverTableComponent;
